// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import SearchFieldWrapper, { SearchFieldWrapperStyles } from "@steiner/App/Components/ReorderPad/SearchFieldWrapper";
import TextField, { TextFieldPresentationProps, TextFieldProps } from "@steiner/MobiusOverrides/TextField";
import React, { FC } from "react";

export interface SearchFieldMfgrNumberProps {
    textFieldProps?: TextFieldProps;
    extendedStyles?: SearchFieldMfgrNumberStyles;
}

export interface SearchFieldMfgrNumberStyles {
    searchFieldWrapperStyles?: SearchFieldWrapperStyles;
    textField?: TextFieldPresentationProps;
}

export const searchFieldMfgrNumberStyles: SearchFieldMfgrNumberStyles = {};

const SearchFieldMfgrNumber: FC<SearchFieldMfgrNumberProps> = React.memo(({ extendedStyles, textFieldProps }) => {
    const [styles] = React.useState(() => mergeToNew(searchFieldMfgrNumberStyles, extendedStyles));

    return (
        <SearchFieldWrapper {...styles.searchFieldWrapperStyles}>
            <TextField {...textFieldProps} {...styles.textField} />
        </SearchFieldWrapper>
    );
});

export default SearchFieldMfgrNumber;
